module.exports = __webpack_public_path__ + "img/31800.de3a3e94.jpg";